/* rg-guides.js - Product Guides: tabs, device carousel, desk, predictive search, deep links, TOC.
   Vanilla, deferred, no dependencies. Reads the device->guides map emitted by rgg-devices.
   URL state: one parser (hash "device=..&type=..", query fallback) used on load and on every
   hashchange; writes preserve the query string and both keys. */
(function () {
  'use strict';
  // Several sections include this asset; the browser executes every <script src> tag it meets.
  // Initialise exactly once per page so no handler is ever registered twice.
  if (window.__rggGuidesInit) return;
  window.__rggGuidesInit = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); };

  /* ------------------------------------------------ device desk ---- */
  var sec = $('#rgg-devices');
  var select = null;
  if (sec) {
    var map = [];
    try { map = JSON.parse(($('#rgg-map') || {}).textContent || '[]'); } catch (e) { map = []; }
    var devs = $$('.rgg-dev[data-handle]', sec);
    var refreshMeta = function () {
      devs.forEach(function (d) {
        var n = guidesFor(d.dataset.handle).length, f = +d.dataset.files || 0;
        var m = $('[data-meta]', d);
        if (m) m.textContent = n + ' guide' + (n === 1 ? '' : 's') + ' · ' + f + ' file' + (f === 1 ? '' : 's');
      });
    };
    // The section emits the map only on page 1 (the page parameter is global). On any other
    // page, fetch this section rendered for page 1 and read the map out of it.
    var mapSrc = sec.dataset.mapSrc;
    if (!map.length && mapSrc && new URLSearchParams(location.search).get('page') > 1) {
      fetch(mapSrc, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var m = /<script[^>]*id="rgg-map"[^>]*>([\s\S]*?)<\/script>/i.exec(html);
        if (!m) return;
        try { map = JSON.parse(m[1]); } catch (e) { return; }
        refreshMeta(); renderDesk();
      }).catch(function () {});
    }
    var track = $('[data-track]', sec), desk = $('[data-desk]', sec);
    var tabs = $$('.rgg-tabs [role="tab"]', sec);
    var FAMS = ['all', 'voice', 'call', 'cam'];
    var tab = 'all', cur = null;
    var famLabel = { voice: sec.dataset.famVoice, call: sec.dataset.famCall, cam: sec.dataset.famCam };
    var guidesFor = function (h) { return map.filter(function (g) { return g.h === h; }); };

    var counts = { all: devs.length, voice: 0, call: 0, cam: 0 };
    devs.forEach(function (d) {
      counts[d.dataset.fam] = (counts[d.dataset.fam] || 0) + 1;
      var n = guidesFor(d.dataset.handle).length, f = +d.dataset.files || 0;
      var m = $('[data-meta]', d);
      if (m) m.textContent = n + ' guide' + (n === 1 ? '' : 's') + ' · ' + f + ' file' + (f === 1 ? '' : 's');
    });
    $$('[data-count]', sec).forEach(function (u) { u.textContent = counts[u.dataset.count] || 0; });

    var readState = function () {
      var h = new URLSearchParams(location.hash.replace(/^#/, ''));
      var q = new URLSearchParams(location.search);
      var t = h.get('type') || q.get('type');
      return { device: h.get('device') || q.get('device'), type: FAMS.indexOf(t) > 0 ? t : null };
    };
    var writeState = function () {
      var h = new URLSearchParams(location.hash.replace(/^#/, ''));
      if (cur) h.set('device', cur.dataset.handle); else h.delete('device');
      if (tab !== 'all') h.set('type', tab); else h.delete('type');
      var frag = h.toString();
      try { history.replaceState(null, '', location.pathname + location.search + (frag ? '#' + frag : '')); } catch (e) {}
    };

    var inTab = function (d) { return tab === 'all' || d.dataset.fam === tab; };
    var syncArrows = function () {
      if (!track) return;
      var over = track.scrollWidth > track.clientWidth + 4;
      var prev = $('.rgg-cbtn--prev', sec), next = $('.rgg-cbtn--next', sec);
      if (prev) prev.hidden = !over || track.scrollLeft < 4;
      if (next) next.hidden = !over || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    var renderTabs = function () {
      tabs.forEach(function (b) {
        var on = b.dataset.t === tab;
        b.classList.toggle('rgg-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
        if (on && track) track.setAttribute('aria-labelledby', b.id);
      });
    };
    var renderTrack = function () {
      devs.forEach(function (d) { d.hidden = !inTab(d); });
      var all = $('[data-all]', sec); if (all) all.hidden = tab !== 'all';
      syncArrows();
    };
    var renderDesk = function () {
      if (!cur) { desk.innerHTML = ''; return; }
      var d = cur, h = d.dataset.handle, gs = guidesFor(h), short = d.dataset.short || '';
      var first = short.split(' ')[0];
      var tpl = $('template[data-dl="' + h + '"]', d);
      var dls = tpl ? tpl.innerHTML : '';
      var title = (sec.dataset.deskTitle || 'Everything for your {device}').replace('{device}', esc(first));
      var empty = (sec.dataset.empty || '').replace('{device}', esc(first));
      var ask = sec.dataset.ask || '/pages/drop-us-a-line';
      var askUrl = ask + (ask.indexOf('?') > -1 ? '&' : '?') + 'product=' + encodeURIComponent(h);
      desk.innerHTML =
        '<div><div class="rgg-desk-hd"><img src="' + esc(d.dataset.img) + '" alt="" loading="lazy"><div><p class="rgg-eb">' + esc(sec.dataset.deskEyebrow || famLabel[d.dataset.fam] || '') + '</p><h3>' + title + '</h3></div><a class="rgg-link" href="' + esc(d.dataset.url) + '">Product page →</a></div>' +
        '<div class="rgg-glist">' + (gs.length ? gs.map(function (g) {
          return '<a class="rgg-gl" href="' + esc(g.u) + '"><span class="rgg-type">' + esc(g.type) + '</span><span><b>' + esc(g.t) + '</b><small>' + esc(g.rt) + ' min · Updated ' + esc(g.d) + '</small></span><span class="rgg-arrow">→</span></a>';
        }).join('') : '<div class="rgg-desk-empty">' + empty + '</div>') + '</div>' +
        '<a class="rgg-ask" href="' + esc(askUrl) + '">Ask about the ' + esc(first) + ' →</a></div>' +
        '<div class="rgg-vr"></div>' +
        '<div class="rgg-side"><h4>Downloads for the ' + esc(first) + '</h4>' + (dls || '<p class="rgg-note">No files for this device yet.</p>') + '</div>';
    };
    var setTab = function (t, opts) {
      opts = opts || {};
      if (FAMS.indexOf(t) < 0) t = 'all';
      tab = t;
      renderTabs(); renderTrack();
      if (cur && !inTab(cur)) { var f = devs.filter(inTab)[0]; cur = f || null; devs.forEach(function (x) { var on = x === cur; x.classList.toggle('rgg-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); }); renderDesk(); }
      if (!opts.silent) writeState();
    };
    select = function (h, opts) {
      opts = opts || {};
      var d = devs.filter(function (x) { return x.dataset.handle === h; })[0];
      if (!d) return false;
      cur = d;
      devs.forEach(function (x) { var on = x === d; x.classList.toggle('rgg-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (!inTab(d)) { tab = d.dataset.fam; renderTabs(); renderTrack(); }
      renderDesk();
      if (!opts.silent) writeState();
      if (opts.scroll) { d.scrollIntoView({ block: 'nearest', inline: 'nearest' }); desk.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
      return true;
    };
    var applyState = function (opts) {
      var st = readState();
      setTab(st.type || 'all', { silent: true });
      if (st.device && select(st.device, { silent: true, scroll: !!(opts && opts.scroll) })) return;
      var f = devs.filter(inTab)[0];
      if (f) select(f.dataset.handle, { silent: true });
    };

    sec.addEventListener('click', function (e) {
      var b = e.target.closest('.rgg-tabs [role="tab"]'); if (b) { setTab(b.dataset.t); b.focus(); return; }
      var c = e.target.closest('.rgg-cbtn'); if (c && track) { track.scrollBy({ left: 480 * (+c.dataset.dir || 1), behavior: 'smooth' }); return; }
      var d = e.target.closest('.rgg-dev[data-handle]'); if (d) select(d.dataset.handle);
    });
    // ARIA tabs: Left/Right/Home/End move focus and selection along the tablist
    sec.addEventListener('keydown', function (e) {
      var b = e.target.closest('.rgg-tabs [role="tab"]'); if (!b) return;
      var i = tabs.indexOf(b), n = tabs.length, j = -1;
      if (e.key === 'ArrowRight') j = (i + 1) % n;
      else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      if (j < 0) return;
      e.preventDefault(); setTab(tabs[j].dataset.t); tabs[j].focus();
    });
    if (track) track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('.rgg-chip[data-handle]');
      if (chip) { e.preventDefault(); select(chip.dataset.handle, { scroll: true }); }
    });
    window.addEventListener('hashchange', function () { applyState({ scroll: true }); });
    applyState({ scroll: !!readState().device });
  }

  /* ------------------------------------------------ predictive search ---- */
  var form = $('.rgg-search');
  if (form) {
    var q = $('#rgg-q', form), box = $('#rgg-sugg', form);
    var blogUrl = form.dataset.blog || '';          // set only when the blog handle resolved
    var timer = null, last = '', seq = 0, ctrl = null;
    // Any dismissal or too-short value invalidates in-flight work, so a slow response can never
    // reopen suggestions the user already closed.
    var invalidate = function () { clearTimeout(timer); timer = null; seq++; if (ctrl && ctrl.abort) ctrl.abort(); ctrl = null; };
    var close = function () { invalidate(); last = ''; box.hidden = true; box.innerHTML = ''; q.setAttribute('aria-expanded', 'false'); };
    var render = function (items) {
      if (!items.length) box.innerHTML = '<div class="rgg-empty">No guides match yet. Try a device name, or a setting like "voice activation".</div>';
      else box.innerHTML = items.map(function (a) {
        return '<a href="' + esc(a.url) + '" role="option"><span class="rgg-type">Guide</span><span><b>' + esc(a.title) + '</b></span></a>';
      }).join('');
      box.hidden = false; q.setAttribute('aria-expanded', 'true');
    };
    var run = function () {
      var v = q.value.trim();
      // Dedupe only against the query whose results are currently SHOWING. A query whose
      // request was aborted must be allowed to run again (abc -> ab -> abc).
      if (v === last && !box.hidden) return;
      if (v.length < 2) { close(); return; }
      invalidate();
      var my = seq;
      ctrl = (typeof window.AbortController === 'function') ? new window.AbortController() : null;
      fetch('/search/suggest.json?q=' + encodeURIComponent(v) + '&resources[type]=article&resources[limit]=8', { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.ok ? r.json() : { resources: { results: { articles: [] } } }; })
        .then(function (j) {
          if (my !== seq) return;                     // a newer query has since been issued
          var arts = ((j.resources || {}).results || {}).articles || [];
          if (blogUrl) arts = arts.filter(function (a) { return String(a.url).indexOf(blogUrl + '/') === 0; });
          last = v;                                    // the query whose results are now showing
          render(arts);
        }).catch(function (err) {
          if (my !== seq) return;                     // a stale failure must never touch the UI
          if (!err || err.name !== 'AbortError') close();
        });
    };
    // Every keystroke invalidates whatever is in flight BEFORE the debounce is scheduled, so a
    // previous query can never resolve and render during the next query's debounce window.
    q.addEventListener('input', function () { invalidate(); timer = setTimeout(run, 180); });
    q.addEventListener('focus', function () { if (q.value.trim().length >= 2) { last = ''; run(); } });
    q.addEventListener('keydown', function (e) {
      var opts = $$('a', box), i = opts.findIndex(function (o) { return o.classList.contains('rgg-on'); });
      if (e.key === 'Escape') { close(); q.blur(); }
      if (e.key === 'ArrowDown' && opts.length) { e.preventDefault(); opts.forEach(function (o) { o.classList.remove('rgg-on'); }); opts[Math.min(opts.length - 1, i + 1)].classList.add('rgg-on'); }
      if (e.key === 'ArrowUp' && opts.length) { e.preventDefault(); opts.forEach(function (o) { o.classList.remove('rgg-on'); }); opts[Math.max(0, i - 1)].classList.add('rgg-on'); }
      if (e.key === 'Enter' && i > -1) { e.preventDefault(); location.href = opts[i].href; }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) {
      var inField = /^(INPUT|TEXTAREA|SELECT)$/.test((document.activeElement || {}).tagName || '');
      if ((e.key === '/' && !inField) || ((e.metaKey || e.ctrlKey) && String(e.key).toLowerCase() === 'k')) { e.preventDefault(); q.focus(); q.select(); }
    });
    $$('.rgg-popular a[data-q]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); q.value = a.dataset.q; q.focus(); last = ''; run(); });
    });
  }

  /* ------------------------------------------------ article TOC ---- */
  var body = $('.rgg-body'), toc = $('.rgg-toc');
  if (body && toc) {
    var hs = $$('h2', body);
    hs.forEach(function (h, i) { if (!h.id) h.id = 'sec-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); });
    toc.innerHTML = hs.map(function (h) { return '<a href="#' + h.id + '">' + esc(h.textContent) + '</a>'; }).join('');
    var tocBox = toc.closest('.rgg-box');
    if (!hs.length && tocBox) tocBox.hidden = true;
    var links = $$('a', toc);
    if ('IntersectionObserver' in window && hs.length) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) links.forEach(function (l) { l.classList.toggle('rgg-on', l.getAttribute('href') === '#' + en.target.id); }); });
      }, { rootMargin: '-20% 0px -70% 0px' });
      hs.forEach(function (h) { io.observe(h); });
    }
  }
})();
